import request from "../base";
const path = "/api/data/email-accounts";

export default {
  get: function (params) {
    return request().get(path + "/", {params});
  },
  delete: function(filter) {
    filter.type = 'soft';

    return request().delete(path + "/", {
      data: filter
    });
  },
  getById: function (id) {
    return request().get(path + "/" + id);
  },
  import: function({attachments, template, delimiter, accounts, tags}) {
    let data = new FormData();

    if (attachments && attachments.length > 0) {
      attachments.forEach(attachment => {
        data.append('attachments', attachment);
      });
      data.append('type', 'file');
      data.append('template', template);
      data.append('delimiter', delimiter || '|');
      tags.forEach(tag => {
        data.append('tags', tag);
      });
    } else {
      data = {
        type: 'json',
        accounts: accounts,
        tags
      }
    }
  
    return request().post(path + "/method/import", data);
  },
  unassignTag: function(params) {
    return request().post(`${path}/${params.id}/unassign-tag`, {tag_id: params.tag_id});
  },
  unassignTagByFilter: function(params) {
    return request().post(path + "/unassign-tag-filter", params);
  },
  checkLiveEmailFilter: function(params) {
    return request().post(path + "/check-live-email-filter", params);
  },
};
